/* eslint-disable global-require */
import Vue from 'vue';
import Router from 'vue-router';
import axios from 'axios';
import storage from 'good-storage';
import store from '../store';
import menuOperated from '../util/menuBtnAuth';
// import StatesData from '../components/common/js/StatesData'
// import api from '../api/apifolder/index'

import { getUserPer, createdRouter } from './getPeromise'

// getUserInfo()

// 解决报错 此方法只针对VueRouter3.0以上
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router);

// 路由懒加载
// 登录
const Login = (resolve) => {
  import('@/components/Login').then((module) => {
    resolve(module);
  });
};
// 首页
const Index = (resolve) => {
  import('@/components/Index').then((module) => {
    resolve(module);
  });
};
// 平台列表
const GameList = (resolve) => {
  import('@/components/GameList').then((module) => {
    resolve(module);
  });
};
// 后台操作引导
// const operateGuidance = (resolve) => {
//   import('@/components/operateGuidance').then((module) => {
//     resolve(module);
//   });
// };
// 404页面未找到
const NotFind = (resolve) => {
  import('@/components/NotFind').then((module) => {
    resolve(module);
  });
};
// 不是该平台用户, 进入的页面
const permissionObj = (resolve) => {
  import('@/components/permissionObj').then((module) => {
    resolve(module);
  });
};
// 没有某个页面的权限
const noPermission = (resolve) => {
  import('@/components/noPermission').then((module) => {
    resolve(module);
  });
};

// 生成的路由
// console.log('生成的路由信息', createdRouter());
const routerChildren = createdRouter()

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originPush = Router.prototype.push;
// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
// eslint-disable-next-line func-names
Router.prototype.push = function (location, resolve, reject) {
  if (resolve && reject) {
    originPush.call(this, location, resolve, reject)
  } else {
    originPush.call(this, location, () => { }, () => { })
  }
}

const router = new Router({
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    {
      path: '/',
      component: Index,
      redirect: '/gamelist',
      beforeEnter(to, from, next) {
        // beforeEnterGetUserInfo(to, from, next)
        store.dispatch({
          type: 'getGameList',
        })
        .then(() => {
          next();
        });
      },
      children: [
        {
          path: 'gamelist',
          name: 'gameList',
          component: GameList,
        },
        // {
        //   path: 'operateGuidance',
        //   name: 'operateGuidance',
        //   component: operateGuidance,
        // },
        ...routerChildren,
      ],
    },
    {
      path: '*',
      name: 'notfind',
      component: NotFind,
    },
    {
      path: '/permissionObj',
      name: 'permissionObj',
      component: permissionObj,
    },
    {
      path: '/noPermission',
      name: 'noPermission',
      component: noPermission,
    },
  ],
});


function getSearchParam(name) {
  const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`, 'i');
  const r = window.location.search.substr(1).match(reg);
  if (r != null) {
    return decodeURIComponent(r[2]);
  }
  return null;
}

function getRemovedTokenInUrl() {
  const removeTokenArray = window.location.href.split('token=');
  const frontPart = removeTokenArray[0].slice(0, removeTokenArray[0].length - 1)
  const hashPart = removeTokenArray[1].split('#')[1]
  console.log('url', `${frontPart}#${hashPart}`)
  return `${frontPart}#${hashPart}`
}

// 路由守卫
router.beforeEach(async (to, from, next) => {
  storage.set('presetstorage', 'a'); // 预设storage 防止在Safari浏览器无效\
  const presetstorage = storage.get('presetstorage')
  if (!presetstorage) {
    // eslint-disable-next-line
    alert('监测到您的浏览器禁用了storage或者不支持设置storage，请启用storage或者更换浏览器。')
  }
  store.commit('setGameId', to.params.id)

  // 首次登陆系统预设token
  const locationSearch = window.location.search // 地址览地址
  if ((locationSearch !== '' && getSearchParam('token'))) {
    storage.set('token', getSearchParam('token'));
    axios.defaults.headers.common['x-xq5-jwt'] = storage.get('token')
      ? storage.get('token')
      : '';
    getUserPer()
    window.history.replaceState({}, document.title, getRemovedTokenInUrl());
  }

  // 不需要验证权限
  const toNames = ['Login', 'gameList', 'noPermission', 'permissionObj', 'NotFind', 'operateGuidance']

  if (toNames.indexOf(to.name) === -1) {
    // 判断权限
    if (!(store.state.menuOperate.menuList && store.state.menuOperate.menuList.length > 0)) {
      await menuOperated.getMenuList();
    }
    // getPermissionAll(to, from, next)
    if (!to.matched[1] || (menuOperated.disposeAutocompleteData().length && !menuOperated.disposeAutocompleteData().find(m => m.path === to.matched[1].path))) {
      next(`/noPermission?from=${to.fullPath}`);
    }
  }

  const storageToken = storage.get('token')  // token
  if (!storageToken) {
    const iframeToken = await Vue.prototype.$Auth.getZonstAuth()
    if (iframeToken) {
      storage.set('token', iframeToken);
      axios.defaults.headers.common['x-xq5-jwt'] = iframeToken;
      getUserPer()
      next();
    } else {
      // 如果是无权限直接跳转到登陆页，否则直接进入当前页 ['#/noPermission', '#/permissionObj']
      const isOriginPage = ['#/noPermission', '#/permissionObj'].indexOf(window.location.hash) < 0
      const url = isOriginPage ?
      window.btoa(encodeURIComponent(window.location.href)) : window.btoa(encodeURIComponent(window.location.origin))
      // if (location.origin.includes('test')) {
      if (process.env.VUE_APP_MODE === 'dev') {
        window.location = `http://login-test.xq5.com/?request_url=${url}&token_in_url=1`;
      } else {
        window.location = `https://login.xq5.com/?request_url=${url}&token_in_url=1`;
      }
      // window.location = `http://login.xq5.com/?request_url=${url}&token_in_url=1`;
    }
  } else {
    getUserPer()
    next();
  }
});

// 当前环境映射
function getAPIType() {
  if (process.env.VUE_APP_MODE === 'master' || process.env.VUE_APP_MODE === 'dev') {
    return '1';
  } else if (process.env.VUE_APP_MODE === 'masternew') {
    return '2'; // 鹰潭
  } else if (process.env.VUE_APP_MODE === 'mastersw') {
    return '3';  // 省外
  }
  return '无法匹配当前环境';
}

store.commit('getAPITypeInVuex', getAPIType());

export default router;
